<template>
  <v-card :width="size+8" :height="size+40" flat class="text-center">
    <v-card outlined :width="size+8" :height="size+8" class="pa-1" @click="click()" :ripple="{ center: true }">
      <v-img v-if="pictureURL" contain :src="pictureURL" :height="size" :width="size"/>
      <v-img v-else contain src="@/assets/image.png" :height="size/2" :width="size/2" class="mx-auto" :style="placeholderY"/>
    </v-card>
    <template v-if="!disabled && !$vuetify.breakpoint.mobile">
      <v-btn icon small @click="click()"><v-icon small>mdi-pencil</v-icon></v-btn>
      <v-btn icon small @click="clear"><v-icon small>mdi-delete</v-icon></v-btn>
    </template>
    <input type="file" accept="image/*" style="display:none" ref="fileInput" @change="newPicture">
    <v-snackbar :timeout="10000" v-model="error" color="error" top>
      {{uploadError}}
      <v-btn plain @click="error=false">Close</v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>

export default {
  name: 'PicturePicker',
	props: {
    value: {type:String,required:false},
    size: {type:Number,required:false,default:200},
    maxMB: {type:Number,required:false,default:1},
    disabled: {type:Boolean,required:false,defualt:false}
  },
  data() {
    return {
//      menu: false,
      files: [],
      pictureURL: null,
      error: false,
      uploadError: '',
    }
  },
  computed: {
    placeholderY() {
      const size = (this.size - this.size/2) / 2;
      return `top:${size}px`;
    }
  },
  watch: {
    value() {
      let pic = this.value;
      if (pic && pic.substring(0, 10) !== 'data:image')
        pic = pic + '?' + Date.now();
      this.pictureURL = pic;
    }
  },
  methods: {
    click() {
      if (!this.disabled)
        this.$refs.fileInput.click();
    },
    newPicture(event) {
      const file = event.target.files[0]
      this.uploadError = '';
      if (file == null) {
        this.pictureURL = this.image.pictureURL;
        return;
      }
      const maxSize = this.maxMB * 1024*1024;
			if (file.size / maxSize > 1) {
        this.uploadError = `File size must be less than ${this.maxMB}MB`;
        this.error = true;
				return;
			}
      const reader = new FileReader();
      reader.onload = loadEvent => {
//        this.menu = false;
        this.pictureURL = loadEvent.target.result;
        this.$emit('input',this.pictureURL);
        this.$emit('change',this.pictureURL);
      }
      reader.onError = () => {
        this.uploadError = 'Error reading file';
        this.error = true;
      }
      reader.readAsDataURL(file);
      this.$refs.fileInput.type='text';   // Required to allow uploading same file
      this.$refs.fileInput.type='file';
    },
    clear() {
      this.pictureURL = '';
//      this.menu = false;
      this.$emit('input',this.pictureURL);
      this.$emit('change',this.pictureURL);
    }
  }
}
</script>